module.exports = __webpack_public_path__ + "static/media/logo.67310b77.png";